var map = {
	"./404_generic.png": 429,
	"./carousel/qello/1.png": 848,
	"./carousel/qello/2.png": 849,
	"./carousel/qello/3.png": 850,
	"./carousel/qello/4.png": 851,
	"./carousel/qello/5.png": 852,
	"./carousel/qello/6.png": 853,
	"./carousel/qello/7.png": 854,
	"./en/stingray_business.png": 855,
	"./en/stingray_classica.jpg": 856,
	"./en/stingray_classica_mobile.jpg": 857,
	"./en/stingray_classica_tablet.jpg": 858,
	"./en/stingray_karaoke.png": 859,
	"./en/stingray_music.jpg": 860,
	"./en/stingray_qello.jpg": 861,
	"./es/stingray_business.png": 862,
	"./fr/stingray_business.png": 863,
	"./fr/stingray_music.png": 864,
	"./popups/classica.png": 865,
	"./popups/music.png": 866,
	"./popups/qello.png": 867
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2052;



//////////////////
// WEBPACK FOOTER
// ./res/images/backgrounds ^\.\/.*$
// module id = 2052
// module chunks = 0